import { Box } from "@mui/material";
import { CardContainer } from "../../../components/base-components/base-componets";
import { BrawlerBuild } from "../brawler.types";
import { useTranslation } from "react-i18next";
import { BuildContainer, DescriptionBuild, ImageBodyContainer, ImageBuildContainer, ImageContainer, Title } from "./build-top.styles";
import { formatNameToTitleCase, getBrawlerImgSrc, getGearSrc, ImageType } from "../../../shared/functions";
import { SharePage } from "../../../components/share-page/share-page";
import { HighlightedTypography } from "../../../components/highlighted-typography/highlighted-typography";
import { componentColors } from "../../../theme";
import { analytics } from "../../../configuration/firebase";
import { logEvent } from "firebase/analytics";

interface Props {
  name: string;
  build: BrawlerBuild;
  pageTitle: string;
}

export const BuildTop: React.FC<Props> = ({
  name,
  build,
  pageTitle
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title component="h2">
        {name}
      </Title>
      <CardContainer>
        <Box padding="8px">
          <ImageContainer>
            <ImageBodyContainer
              component="img"
              alt={name}
              src={getBrawlerImgSrc(ImageType.BODY, name)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getBrawlerImgSrc(ImageType.BODY);
                logEvent(analytics, 'image_error', {
                  name: name,
                });
              }}
            />
          </ImageContainer>
          <DescriptionBuild>
            {t("PAGES.BRAWLER.BUILD.DESCRIPTION")}
          </DescriptionBuild>
          <BuildContainer>
            <ImageBuildContainer
              component="img"
              alt="Starpower build"
              src={getBrawlerImgSrc(ImageType.STAR_POWER, name, build.starPower)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getBrawlerImgSrc(ImageType.STAR_POWER);
                logEvent(analytics, 'image_error', {
                  name: name,
                });
              }}
            />
            <ImageBuildContainer
              component="img"
              alt="Gadget build"
              src={getBrawlerImgSrc(ImageType.GADGETS, name, build.gadget)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getBrawlerImgSrc(ImageType.GADGETS);
                logEvent(analytics, 'image_error', {
                  name: name,
                });
              }}
            />
            <ImageBuildContainer
              component="img"
              alt="Gear 1 build"
              src={getGearSrc(build.gear1)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getGearSrc();
                logEvent(analytics, 'image_error', {
                  name: build.gear1,
                });
              }}
            />
            <ImageBuildContainer
              component="img"
              alt="Gear 2 build"
              src={getGearSrc(build.gear2)}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getGearSrc();
                logEvent(analytics, 'image_error', {
                  name: build.gear2,
                });
              }}
            />
          </BuildContainer>
        </Box>
        <SharePage
          shareTitle={pageTitle + "!"}
          shareChild={
            <HighlightedTypography
              text={t("PAGES.BRAWLER.SHARE", { brawler: formatNameToTitleCase(name) })}
              highlights={[{ word: name ?? "", color: componentColors.linkText }]}
            />
          }
        />
      </CardContainer>
    </Box>
  );
}
